"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0a8 8 0 100 16h8V8a8 8 0 00-8-8zM6 9a1 1 0 011 1v2.49a.51.51 0 00.948.26l2.986-5.039a.47.47 0 00-.405-.71H10a1 1 0 01-1-1V3.51a.51.51 0 00-.948-.26L5.066 8.289A.471.471 0 005.47 9H6z"];
//# sourceMappingURL=explain.js.map